import React from 'react';

import { UIFormClient } from '../../../../../external/UIFormClient/domain/abstract/UIFormClient';
import { IUserFormCreator } from '../../../domain/interfaces';

export type TUserCreationFormView = React.PropsWithChildren<{
  UserFormCreator: UIFormClient<IUserFormCreator>;
}>;

export const UserCreationFormView: React.FC<TUserCreationFormView> = ({
  UserFormCreator,
}) => {
  return (
    <UserFormCreator.renderForm
      onSubmitHandler={async (values, formikHelpers) => {
        alert(values);
        return formikHelpers.submitForm;
      }}
    />
  );
};
